var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cake paul"},[_c('img',{attrs:{"src":'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/cake-topper.jpg',"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699a6f34","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Base/Cake.vue
// module id = 410
// module chunks = 0